import React, { useRef } from 'react';
import InputWrapper from './InputField.style';
import { SIGNUP_ERROR_MSG } from '../../utils/constants';

type InputFieldType = {
  input?: {
    name: string;
    value: string;
  };
  autoComplete?: string;
  className?: string;
  label?: string;
  meta?: {
    error: string;
    invalid: boolean;
    valid: boolean;
    touched: boolean;
  };
  placeholder?: string;
  tooltipDisplay?: boolean;
  type?: string;
  id?: string;
  icon?: any;
  iconStyles?: any;
  onIconClick?: () => any;
  disabled?: boolean;
  customStyle?: {
    width?: string;
  };
  messageStyle?: any;
  message?: string;
  noErrMsg?: boolean;
};

const InputField: React.FC<InputFieldType> = (props) => {
  const {
    label,
    input,
    id,
    icon,
    iconStyles,
    disabled,
    onIconClick,
    meta,
    customStyle,
    messageStyle,
    message,
    noErrMsg = false,
    className,
    placeholder,
    type
  } = props;
  const ID = input ? input.name : id;
  const inputRef = useRef<any>();
  let ICON_ALT = icon?.split('/').pop();
  ICON_ALT = ICON_ALT?.substr(0, ICON_ALT?.indexOf('.'));

  return (
    <InputWrapper
      id={ID}
      $valueExist={input?.value.length !== 0}
      disabled={disabled}
      $invalid={meta?.touched && meta.invalid && meta.error !== ''}
      style={{ ...customStyle }}
      $messagePadding={messageStyle ? true : false}
      $message={message ? true : false}
      $errorPadding={meta?.error === 'Required' && label === "Applicant's mobile number"}
      $responsive={customStyle?.width ? true : false}
      $noErrMsg={meta?.error === ' ' && noErrMsg}
      className={className}
    >
      <div>
        <label htmlFor={ID + '-input'}>{label}</label>
        <input
          onBlur={(e) => {
            e.preventDefault();
          }}
          ref={inputRef}
          id={ID + '-input'}
          className={className}
          placeholder={placeholder}
          type={type}
          disabled={disabled}
          {...props.input}
          // eslint-disable-next-line max-len
          autoComplete={props.autoComplete || 'new-password'} // disabling autocomplete due to issues with few old version browsers NINSTA-16031
        />
        {icon && (
          <img
            style={{ ...iconStyles }}
            src={icon}
            onClick={() => {
              !disabled && onIconClick && onIconClick();
            }}
            alt={ICON_ALT}
          />
        )}
      </div>
      {meta?.error && meta.touched && !noErrMsg && (
        <p className={message && meta.error && 'input-error-msg'} id="err-msg">
          {meta.error}
        </p>
      )}
      {message === SIGNUP_ERROR_MSG && meta?.error && meta.touched && (
        <p className="err-msg">{message}</p>
      )}

      {message &&
        ((message === SIGNUP_ERROR_MSG && !meta?.touched) || message !== SIGNUP_ERROR_MSG) && (
          <p className="input-message">{message}</p>
        )}
    </InputWrapper>
  );
};

export default InputField;
